/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const Tick = (props) => {
  return (
    <BaseSvgIcon size="25px" {...props}>
      <path d="M7.33883476,12.2027958 L14.4099026,5.13172798 C14.8004269,4.74120369 15.4335918,4.74120369 15.8241161,5.13172798 C16.2146404,5.52225228 16.2146404,6.15541725 15.8241161,6.54594155 L8.04594155,14.3241161 C7.65541725,14.7146404 7.02225228,14.7146404 6.63172798,14.3241161 C6.57519527,14.2675834 6.52684628,14.205966 6.48668104,14.140736 C6.42145102,14.1005707 6.35983358,14.0522217 6.30330086,13.995689 L4.18198052,11.8743687 L4.18198052,11.8743687 C3.79145622,11.4838444 3.79145622,10.8506794 4.18198052,10.4601551 L4.18198052,10.4601551 L4.18198052,10.4601551 C4.57250481,10.0696308 5.20566979,10.0696308 5.59619408,10.4601551 L7.33883476,12.2027958 Z" />
    </BaseSvgIcon>
  )
}

export default Tick
